export enum PackagesTracker {
	SETTINGS = 'settings',
	TAB_CHANGE = 'package_tabchange',
	TOGGLED = 'package_toggled',
	SEARCH_ACTIVATE = 'package_search_activate',
	PACKAGE_DETAILS = 'package_config_settings',
	DETAILS_TOGGLED = 'package_config_toggled',
	TOGGLE_ALL_ADDONS = 'package_config_all_addons',
	TOGGLE_ALL_PACKAGES = 'package_select_all',
}
